import { Field } from "formik";
import ReCaptcha from "@/components/CustomComponents/ContactUsForm/ReCaptcha";
const captchaDisabled = process.env.NEXT_PUBLIC_RECAPTCHA_DISABLE === "0";

export const renderField = (
  setFieldValue,
  field,
  error,
  touched,
  setSelected,
  selected
) => {
  switch (field.type) {
    case "textarea":
      return (
        <Field
          as="textarea"
          name={field.name}
          rows={5}
          className={inputClass(field.name, error, touched)}
        />
      );

    case "select":
      return (
        <Field
          as="select"
          name={field.name}
          className={inputClass(field.name, error, touched)}
        >
          {field.options?.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Field>
      );

    case "radioButton":
      return (
        <>
          {field?.radioButtonOptions?.map((option, index) => (
            <label key={option} className="flex items-center gap-2">
              <Field
                type="radio"
                name={field.name}
                value={option}
                className="h-4 w-4"
                checked={selected === index}
                onChange={() => {
                  setSelected(index);
                  setFieldValue(field.name, option);
                }}
              />
              <span>{option}</span>
            </label>
          ))}
        </>
      );

    case "checkbox":
      return (
        <label
          htmlFor={field.name}
          className="flex items-center gap-2 cursor-pointer"
        >
          <Field
            type="checkbox"
            name={field.name}
            id={field.name}
            className="h-4 w-4"
          />
          <span dangerouslySetInnerHTML={{ __html: field.label }} />{" "}
        </label>
      );

    case "captcha":
      return (
        !captchaDisabled && (
          <ReCaptcha
            siteKey={process.env.NEXT_PUBLIC_RECAPTCHA_V2_SITE_KEY}
            onChange={token => {
              setFieldValue("captchaToken", token || "");
            }}
            onExpired={() => setFieldValue("captchaToken", "")}
            onError={() => setFieldValue("captchaToken", "")}
          />
        )
      );

    default:
      return (
        <>
          <Field
            type={field.type}
            name={field.name}
            className={inputClass(field.name, error, touched)}
          />{" "}
          <div className="text-sm text-gray-500">{field?.textpart}</div>
        </>
      );
  }
};
function inputClass(name, errors, touched) {
  const base =
    "w-full border rounded px-3 py-2 text-[14px] !font-['HelveticaRoman', Helvetica, sans-serif]";
  return errors && touched
    ? `${base} border-red-500`
    : `${base} border-slate-300`;
}
